export default __webpack_public_path__ + "static/media/vehicle.031f92e7021463a529ac572d0616a0fa.svg";